import { Add, ArrowDropDown } from '@mui/icons-material';
import { Button, ButtonProps } from '@mui/material';
import { ReactNode, forwardRef } from 'react';
import FiltersBadge from '../Badge';

interface IProps extends ButtonProps {
  describedBy?: string;
  endAdornment?: ReactNode;
  startAdornment?: ReactNode;
  badgeCount?: number;
}

const AddFilterButton = forwardRef<HTMLButtonElement, IProps>(
  (
    {
      sx,
      onClick,
      describedBy,
      endAdornment = <ArrowDropDown sx={{ width: 16, height: 16 }} />,
      startAdornment = <Add sx={{ width: 16, height: 16 }} />,
      badgeCount,
      ...props
    }: IProps,
    ref,
  ) => {
    return (
      <Button
        ref={ref}
        variant='contained'
        onClick={onClick}
        aria-describedby={describedBy}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          height: '37px',
          ...sx,
        }}
        {...props}
      >
        {startAdornment}
        <span>Add Filter</span>
        <FiltersBadge count={badgeCount} sx={{ ml: '2px' }} />
        {endAdornment}
      </Button>
    );
  },
);

export default AddFilterButton;
